enum PaymentMethodProviderType {
    Api = 'PAYMENT_TYPE_API',
    Hosted = 'PAYMENT_TYPE_HOSTED',
    Offline = 'PAYMENT_TYPE_OFFLINE',
}

export default PaymentMethodProviderType;
